// // /////serach icon filter corrrectly but online,offline,oncall works only in the current page
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Modal,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
  Form,
  ModalBody,
  Label,
  ModalFooter,
} from "reactstrap";
import { CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";

import { Link } from "react-router-dom";
import {
  PlusSquare,
  Wifi,
  WifiOff,
  Target,
  PhoneCall,
  Video,
  Eye,
  Mail,
  Phone,
  MapPin,
  Globe,
  Star,
  Clock,
  DollarSign,
  Activity,
  FileText,
} from "react-feather"; // added PhoneCall
import axios from "axios";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import { ViewAgentTitle, AgentTitle, Href } from "../../../Utils/Constants";
import { Badges, H5, P, UL, LI, Image, Btn } from "../../../AbstractElements";
import { baseUrl, mediaUrl, uploadFile } from "../../../Utils/FileUpload";
import FilterComponent from "../../../Components/Tables/DataTables/Common/FilterComponent";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import StarRatings from "react-star-ratings";
import { useForm, Controller } from "react-hook-form";
import { useDebouncedCallback } from "use-debounce";
import { useAuth } from "../../../Context/AuthContext";
// ✅ Updated with "On Call" status tab
const projectListNavList = [
  { id: 1, icon: <Target />, text: "All" },
  { id: 2, icon: <Wifi />, text: "Online" },
  { id: 3, icon: <WifiOff />, text: "Offline" },
  { id: 4, icon: <PhoneCall />, text: "On Call" },
];
interface Agent {
  id: string;
  agent_name: string;
  email: string;
  address: string;
  phone: string;
  image: string;
  is_online: number;
  is_active: number;
  languages?: { language: string; icon: string }[];
  // brands?: { brand_name: string; logo: string }[];
  is_deleted: number;
}

export default function ViewAgent() {
  const [activeTab, setActiveTab] = useState(1);
  const [disabledDelete, setDisabledDelete] = useState<string | null>(null);
  const [disableAllDelete, setDisableAllDelete] = useState(false);
  const [filteredItems, setFilteredItems] = useState<Agent[]>([]);
  const [refresh, setRefresh] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [disabledEnable, setDisabledEnable] = useState<string | null>(null);
  const [disableAllEnable, setDisableAllEnable] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const { hasPermission } = useAuth();
  const [filterText, setFilterText] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState<number>(6);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [prevPageBeforeSearch, setPrevPageBeforeSearch] = useState<number>(1);
  const [status, setStatus] = useState<number | null>(null);
  const [showPayoutModal, setShowPayoutModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState<any>(null);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedAgentDetail, setSelectedAgentDetail] = useState<any>(null);
  const [modalActiveTab, setModalActiveTab] = useState("1");
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();
  const fetchData = async (
    page = currentPage,
    currentPerPage = perPage,
    searchText = filterText,
    currentStatus: number | null = status
  ) => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseUrl}agent/get_all_paginated`, {
        params: {
          page,
          per_page: currentPerPage,
          search: searchText.trim() !== "" ? searchText : undefined,
          status: currentStatus,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data: Agent[] = response.data.data;
      const paginationInfo = response.data;
      setFilteredItems(data);
      setTotalPages(paginationInfo.last_page || 1);
      setCurrentPage(paginationInfo.current_page || 1);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetch = useDebouncedCallback(
    (searchVal: string, pageVal: number, perPageVal: number, statusVal: number | null) => {
      fetchData(pageVal, perPageVal, searchVal, statusVal);
    },
    400
  );

  // Fetch data whenever the active tab changes
  useEffect(() => {
    const newStatus =
      activeTab === 1 ? null : activeTab === 2 ? 1 : activeTab === 3 ? 0 : 2;
    setStatus(newStatus);
    setCurrentPage(1);
    fetchData(1, perPage, filterText, newStatus);
  }, [activeTab, refresh]);

  // Handle page change
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchData(page, perPage, filterText, status);
  };

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchInput(value);
    setFilterText(value);
    setCurrentPage(1);
    debouncedFetch(value, 1, perPage, status);
  };

  const handleSearchClick = () => {
    setCurrentPage(1);
    setFilterText(searchInput);
    fetchData(1, perPage, searchInput, status);
  };

  const handleReset = () => {
    setSearchInput("");
    setFilterText("");
    setCurrentPage(1);
    fetchData(1, perPage, "", status);
  };

  const handleAdd = () => {
    navigate("/add_agent");
  };

  const handlehistory = () => {
    navigate("/call_history");
  };

  const handleVideoHistory = () => {
    navigate("/video_call_history");
  };

  const getFilteredAgents = () => {
    return filteredItems;
  };

  const handleEdit = (id: string) => {
    navigate("/edit_agent", { state: { id: id } });
  };

  const handleagenthistory = (id: string) => {
    navigate("/call_history", { state: { agent_id: id } });
  };

   const handleVideoCallHistory = (id: string) => {
    navigate("/video_call_history", { state: { agent_id: id } });
  };

  const handleDelete = (id: string) => {
    setDisabledDelete(id);
    setDisableAllDelete(true);
    const confirmToast = () =>
      toast.warn(
        <div>
          <div>Are you sure you want to delete this agent?</div>
          <div className="d-flex justify-content-end mt-2">
            <Button color="danger" onClick={() => confirmDelete(id)}>
              Yes
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                setDisabledDelete(null);
                setDisableAllDelete(false);
                toast.dismiss();
              }}
              className="ms-2"
            >
              Cancel
            </Button>
          </div>
        </div>,
        {
          position: "top-right",
          autoClose: false,
          closeOnClick: false,
          closeButton: false,
          draggable: false,
          onClose: () => {
            setDisableAllDelete(false);
            setDisabledDelete(null);
          },
        }
      );

    const confirmDelete = async (id: string) => {
      setDisabledDelete(null);
      setDisableAllDelete(false);
      toast.dismiss();
      try {
        await axios.post(
          `${baseUrl}agent/delete`,
          { id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success(`Agent Deleted Successfully`, {
          position: "top-right",
          autoClose: 1000,
          closeOnClick: true,
          onClose: () => {
            setRefresh((prev) => prev + 1);
          },
        });
      } catch (error) {
        console.error("Error deleting agent:", error);
        toast.error("An error occurred while deleting the agent", {
          position: "top-right",
          autoClose: 1000,
          closeOnClick: true,
        });
      }
    };

    confirmToast();
  };

  const toggleEnable = (id: string, currentStatus: number) => {
    setDisabledEnable(id); // reuse this state if needed
    setDisableAllEnable(true);

    const confirmToggle = () => {
      toast.warn(
        <div>
          <div>
            Are you sure you want to{" "}
            <strong>{currentStatus === 1 ? "disable" : "enable"}</strong> this
            agent?
          </div>
          <div className="d-flex justify-content-end mt-2">
            <Button
              color={currentStatus === 1 ? "danger" : "success"}
              onClick={() => confirmToggleEnable(id, currentStatus)}
            >
              Yes
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                setDisabledEnable(null);
                setDisableAllEnable(false);
                toast.dismiss();
              }}
              className="ms-2"
            >
              Cancel
            </Button>
          </div>
        </div>,
        {
          position: "top-right",
          autoClose: false,
          closeOnClick: false,
          closeButton: false,
          draggable: false,
          onClose: () => {
            setDisabledEnable(null);
            setDisableAllEnable(false);
          },
        }
      );
    };

    const confirmToggleEnable = async (id: string, currentStatus: number) => {
      setDisabledEnable(null);
      setDisableAllEnable(false);
      toast.dismiss();

      try {
        const newStatus = currentStatus === 1 ? 0 : 1;

        await axios.post(
          `${baseUrl}agent/toggle_active`,
          { id, is_active: newStatus },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        toast.success(
          `Agent ${newStatus === 1 ? "enabled" : "disabled"} successfully!`,
          {
            position: "top-right",
            autoClose: 1000,
            closeOnClick: true,
            onClose: () => {
              setRefresh((prev) => prev + 1);
            },
          }
        );
      } catch (error) {
        console.error("Error toggling agent:", error);
        toast.error("Error updating enable status", {
          position: "top-right",
          autoClose: 1000,
        });
      }
    };

    confirmToggle();
  };

  const getStatusDetails = (status: number) => {
    switch (status) {
      case 1:
        return { text: "Online", color: "success" };
      case 0:
        return { text: "Offline", color: "danger" };
      case 2:
        return { text: "On Call", color: "warning" };
      default:
        return { text: "Unknown", color: "secondary" };
    }
  };
  const onSubmit = async (data: any) => {
    try {
      const file = data.document?.[0];
      if (!file) {
        toast.error("Please upload a document.");
        return;
      }

      const fileName = await uploadFile(file);

      const payload = {
        ...data,
        document: fileName,
        agent_id: selectedAgent.id,
        id: selectedAgent.call_payouts.id,
        transaction_id: data.transactionId,
        isrequest: 0,
        amount: selectedAgent.total_amount_without_currency,
        callstartdate: selectedAgent.call_duration_start_date,
        callenddate: selectedAgent.call_duration_end_date,
        is_paid: 1,
      };
      // console.log(payload)
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${baseUrl}call_payroll/update`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data?.message) {
        // ✅ Show toast for 2 seconds and call fetchData after toast closes
        toast.success(response.data.message, {
          autoClose: 1000,
          onClose: () => {
            fetchData(currentPage, perPage);
            reset();
            setShowPayoutModal(false);
            setSelectedAgent(null);
          },
        });
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        "An error occurred while updating the payout.";
      toast.error(errorMessage);
    }
  };

  const formatPhoneNumber = (phone: string): string => {
    const digitsOnly = phone.replace(/\D/g, ""); // remove all non-digits

    if (digitsOnly.startsWith("91")) {
      return `+${digitsOnly.slice(0, 2)} ${digitsOnly.slice(2)}`;
    } else {
      return `+${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3)}`;
    }
  };
  return (
    <>
      <Breadcrumbs
        pageTitle={ViewAgentTitle}
        parent={AgentTitle}
        title={ViewAgentTitle}
      />
      <Container fluid>
        <Row className="project-cards">
          <Col md={12} className="project-list">
            <Card>
              <Row className="align-items-center">
                <Col xs={12} md={6} className="mb-3 mb-md-0">
                  <Nav className="border-tab" tabs>
                    {projectListNavList.map((item) => (
                      <NavItem key={item.id}>
                        <NavLink
                          href={Href}
                          className={activeTab === item.id ? "active" : ""}
                          onClick={() => {
                            setActiveTab(item.id);
                            setCurrentPage(1);
                            const newStatus =
                              item.id === 1
                                ? null
                                : item.id === 2
                                ? 1
                                : item.id === 3
                                ? 0
                                : 2;
                            setStatus(newStatus);
                            fetchData(1, perPage, searchInput, newStatus);
                          }}
                        >
                          {item.icon}
                          {item.text}
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>
                </Col>

                <Col xs={12} md={6} className="text-md-end text-start">
                  <FormGroup className="mb-0 d-flex flex-wrap justify-content-md-end justify-content-start gap-2">
                    {hasPermission("agent.call_history_view") && (
                      <Btn
                        color="success"
                        onClick={handlehistory}
                        className="btn btn-success d-flex align-items-center justify-content-center"
                      >
                        <PhoneCall className="me-2" /> Call History
                      </Btn>
                    )}
                    {hasPermission("agent.add") && (
                      <Btn
                        color="primary"
                        onClick={handleAdd}
                        className="btn btn-primary d-flex align-items-center justify-content-center"
                      >
                        <PlusSquare className="me-2" /> Add Agent
                      </Btn>
                    )}
                  </FormGroup>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col sm={12}>
            <Card>
              <CardBody>
                <div className="mb-3">
                  <FilterComponent
                    onFilter={handleSearchInputChange}
                    filterText={searchInput}
                  />
                </div>
                <TabContent activeTab={activeTab}>
                  {loading ? (
                    <TabPane tabId={activeTab}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          minHeight: "300px",
                          width: "100%",
                        }}
                      >
                        <Spinner color="primary" />
                      </div>
                    </TabPane>
                  ) : getFilteredAgents().length > 0 ? (
                    <TabPane tabId={activeTab}>
                      <Row>
                        {getFilteredAgents().map((item: any, index) => {
                          const { text: badgeText, color: badgeColor } =
                            getStatusDetails(item.is_online);
                          return (
                            <Col xxl={4} md={6} key={index}>
                              <div
                                className={`project-box font-dark bg-light-${badgeColor}`}
                              >
                                <Badges color={badgeColor}>{badgeText}</Badges>
                                <H5
                                  className={`f-w-500 mb-2 text-${badgeColor}`}
                                >
                                  {item.agent_name}
                                  {item.is_terms_and_conditions == 1 && (
                                    <i
                                      className="fa fa-check-circle text-primary ms-2"
                                      title="Verified Agent"
                                      style={{ fontSize: "16px" }}
                                    />
                                  )}
                                </H5>
                                <div className="d-flex mb-2 align-items-center justify-content-between">
                                  <div className="d-flex align-items-center">
                                    <Image
                                      className="img-30 me-2 rounded-circle"
                                      src={`${mediaUrl}/${item.image}`}
                                      alt="agent"
                                    />
                                    <P className="font-light mb-0">
                                      {item.email}
                                    </P>
                                  </div>

                                  {item.call_payouts?.isrequest === 1 && (
                                    <Button
                                      color="success"
                                      size="sm"
                                      onClick={() => {
                                        setSelectedAgent(item);
                                        setShowPayoutModal(true);
                                      }}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                      title="Pay Now"
                                    >
                                      Pay Now
                                    </Button>
                                  )}
                                </div>
                                <P className="mb-2">{item.address}</P>
                                <Row
                                  className="details"
                                  // style={{ height: "150px" }}
                                >
                                  <Col xs={4}>
                                    <span>Phone</span>
                                  </Col>
                                  <Col xs={8} className={`font-${badgeColor}`}>
                                    {formatPhoneNumber(item.phone)}
                                  </Col>

                                  <Col xs={4}>
                                    <span>Languages</span>
                                  </Col>
                                  <Col xs={8}>
                                    <div className="d-flex align-items-center flex-wrap gap-1 mb-1">
                                      {item.languages?.map(
                                        (lang: any, idx: number) => (
                                          <Image
                                            key={idx}
                                            className="img-20 rounded-circle"
                                            src={`${mediaUrl}/${lang.icon}`}
                                            alt={lang.language}
                                            title={lang.language}
                                          />
                                        )
                                      )}
                                    </div>
                                    {item.languages
                                      ?.map((lang: any) => lang.language)
                                      .join(", ")}
                                  </Col>

                                  {/* <Col xs={4}>
                                    <span>Brands</span>
                                  </Col>
                                  <Col xs={8}>
                                    <div className="d-flex align-items-center flex-wrap gap-1 mb-1">
                                      {item.brands?.map(
                                        (brand: any, idx: number) => (
                                          <Image
                                            key={idx}
                                            className="img-20 rounded-circle"
                                            src={`${mediaUrl}/${brand.logo}`}
                                            alt={brand.brand_name}
                                            title={brand.brand_name}
                                          />
                                        )
                                      )}
                                    </div>
                                    {item.brands
                                      ?.map((brand: any) => brand.brand_name)
                                      .join(", ")}
                                  </Col> */}

                                  <Col xs={4}>
                                    <strong className="d-block">
                                      {" "}
                                      Call Duration
                                    </strong>
                                  </Col>
                                  <Col xs={8}>
                                    <div className="d-flex align-items-center flex-wrap gap-1 mb-1">
                                      {item.total_call_duration}
                                    </div>
                                  </Col>
                                </Row>
                                <Col xs={12} className="mt-2">
                                  <div className="d-flex flex-wrap justify-content-between gap-3">
                                    <div className="d-flex align-items-center">
                                      <i className="fa fa-dollar-sign text-success me-2 fs-5" />
                                      <div>
                                        <strong className="d-block">
                                          Revenue Generated
                                        </strong>
                                        <strong className="d-block">
                                          by Agent
                                        </strong>
                                        <span className="text-muted">
                                          {item.total_customer_amount}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <i className="fa fa-wallet text-warning me-2 fs-5" />
                                      <div>
                                        <strong className="d-block">
                                          Agent's Pending
                                        </strong>
                                        <strong className="d-block">
                                          Payout
                                        </strong>
                                        <span className="text-muted">
                                          {item.total_amount}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </Col>

                                <Col
                                  xs={12}
                                  className="mt-2"
                                  style={{ zIndex: 2 }}
                                >
                                  <div className="d-flex align-items-center justify-content-between flex-nowrap gap-1">
                                    {/* Left: Compact Buttons */}
                                    <div className="d-flex align-items-center gap-1 flex-nowrap">
                                      {hasPermission("agent.enable_disable") && (
                                        <Button
                                          color={
                                            item.is_active
                                              ? "success"
                                              : "secondary"
                                          }
                                          onClick={() =>
                                            toggleEnable(item.id, item.is_active)
                                          }
                                          disabled={
                                            disabledEnable === item.id ||
                                            disableAllEnable
                                          }
                                          style={{
                                            padding: "3px 6px",
                                            fontSize: "11px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            height: "26px",
                                            minWidth: "26px",
                                          }}
                                          title={
                                            item.is_active ? "Disable" : "Enable"
                                          }
                                        >
                                          <i
                                            className={`fa ${
                                              item.is_active
                                                ? "fa-check-circle"
                                                : "fa-ban"
                                            }`}
                                            style={{ fontSize: "11px" }}
                                          />
                                        </Button>
                                      )}

                                      {hasPermission("agent.edit") && (
                                        <Button
                                          color="primary"
                                          onClick={() => handleEdit(item.id)}
                                          style={{
                                            padding: "3px 6px",
                                            fontSize: "11px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            height: "26px",
                                            minWidth: "26px",
                                          }}
                                          title="Edit"
                                        >
                                          <i className="icon-pencil-alt" style={{ fontSize: "11px" }} />
                                        </Button>
                                      )}

                                      {hasPermission("agent.delete") && (
                                        <Button
                                          color="danger"
                                          onClick={() => handleDelete(item.id)}
                                          disabled={
                                            disabledDelete === item.id ||
                                            disableAllDelete
                                          }
                                          style={{
                                            padding: "3px 6px",
                                            fontSize: "11px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            height: "26px",
                                            minWidth: "26px",
                                          }}
                                          title="Delete"
                                        >
                                          <i className="icon-trash" style={{ fontSize: "11px" }} />
                                        </Button>
                                      )}

                                      {hasPermission("agent.call_history_view") && (
                                        <Button
                                          color="info"
                                          onClick={() =>
                                            handleagenthistory(item.id)
                                          }
                                          style={{
                                            padding: "3px 6px",
                                            fontSize: "11px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            height: "26px",
                                            minWidth: "26px",
                                          }}
                                          title="Call History"
                                        >
                                          <i className="fa fa-phone" style={{ fontSize: "11px" }} />
                                        </Button>
                                      )}

                                      {hasPermission("agent.payout") && (
                                        <Button
                                          color="warning"
                                          onClick={() => {
                                            navigate("/payout_report", {
                                              state: {
                                                agentId: item.id,
                                              },
                                            });
                                          }}
                                          style={{
                                            padding: "3px 6px",
                                            fontSize: "11px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            height: "26px",
                                            minWidth: "26px",
                                          }}
                                          title="Payout"
                                        >
                                          <i className="fa fa-money-bill-wave" style={{ fontSize: "11px" }} />
                                        </Button>
                                      )}

                                      <Button
                                        color="info"
                                        onClick={() => {
                                          setSelectedAgentDetail(item);
                                          setDetailModalOpen(true);
                                        }}
                                        style={{
                                          padding: "3px 6px",
                                          fontSize: "11px",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          height: "26px",
                                          minWidth: "26px",
                                        }}
                                        title="View Details"
                                      >
                                        <Eye size={12} />
                                      </Button>
                                    </div>

                                    {/* Right: Compact Rating */}
                                    <div
                                      className="text-end flex-shrink-0"
                                      style={{
                                        fontSize: "0.8rem",
                                        fontWeight: "bold",
                                        lineHeight: "1.1",
                                      }}
                                    >
                                      <div
                                        title={`Average Rating: ${item.average_rating}`}
                                      >
                                        <StarRatings
                                          rating={item.average_rating}
                                          starRatedColor="#ffd700"
                                          numberOfStars={5}
                                          starDimension="16px"
                                          starSpacing="1px"
                                        />
                                      </div>
                                      <span style={{ fontSize: "11px", color: "#6c757d" }}>
                                        ({item.rating_count} Review)
                                      </span>
                                    </div>
                                  </div>
                                </Col>
                              </div>
                            </Col>
                          );
                        })}
                      </Row>
                      <Row className="justify-content-end mt-3">
                        <Col xl="auto">
                          <div className="d-flex gap-2 flex-wrap">
                            {/* Previous Button */}
                            <Button
                              color="primary"
                              disabled={currentPage === 1}
                              onClick={() => handlePageChange(currentPage - 1)}
                            >
                              <FaArrowLeft size={18} />
                            </Button>

                            {/* Page Numbers */}
                            {Array.from(
                              { length: totalPages },
                              (_, i) => i + 1
                            ).map((page) => (
                              <Button
                                key={page}
                                color={
                                  page === currentPage ? "success" : "secondary"
                                }
                                onClick={() => handlePageChange(page)}
                              >
                                {page}
                              </Button>
                            ))}

                            {/* Next Button */}
                            <Button
                              color="primary"
                              disabled={currentPage === totalPages}
                              onClick={() => handlePageChange(currentPage + 1)}
                            >
                              <FaArrowRight size={18} />
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  ) : (
                    <TabPane tabId={activeTab}>
                      <div className="text-center mt-5">
                        <h5>No agents available</h5>
                      </div>
                    </TabPane>
                  )}
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {showPayoutModal && selectedAgent && (
          <Modal
            isOpen={showPayoutModal}
            toggle={() => setShowPayoutModal(false)}
          >
            <ModalHeader toggle={() => setShowPayoutModal(false)}>
              Agent Payout - {selectedAgent.agent_name}
            </ModalHeader>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <ModalBody>
                <Row className="g-3">
                  <Col xs={12}>
                    <strong>Payment Duration:</strong>
                    <br />
                    {selectedAgent.call_duration_start_date} to{" "}
                    {selectedAgent.call_duration_end_date}
                  </Col>
                  <Col xs={12}>
                    <strong>Total Call Duration:</strong>
                    <br />
                    {selectedAgent.total_call_duration}
                  </Col>
                  <Col xs={12}>
                    <strong>Total Amount:</strong>
                    <br />
                    {selectedAgent.total_amount}
                  </Col>
                  <Col xs={12}>
                    <Label htmlFor="transactionId">Transaction ID</Label>
                    <Controller
                      name="transactionId"
                      control={control}
                      rules={{ required: "Transaction ID is required" }}
                      render={({ field }) => (
                        <Input
                          type="text"
                          {...field}
                          placeholder="Enter Transaction ID"
                        />
                      )}
                    />
                    {errors.transactionId &&
                      typeof errors.transactionId.message === "string" && (
                        <span className="text-danger">
                          {errors.transactionId.message}
                        </span>
                      )}
                  </Col>
                  <Col xs={12}>
                    <Label htmlFor="proof">Upload Payment Proof</Label>
                    <Controller
                      name="document"
                      control={control}
                      rules={{
                        required: "Payment proof is required",
                        validate: {
                          isImage: (value) => {
                            if (!value || !value[0]) return "File is required";
                            const acceptedTypes = [
                              "image/jpeg",
                              "image/png",
                              "image/gif",
                              "image/webp",
                              "image/svg+xml",
                            ];
                            return acceptedTypes.includes(value[0].type)
                              ? true
                              : "Only image files are allowed (JPEG, PNG, GIF, WEBP, SVG)";
                          },
                          maxSize: (value) => {
                            if (!value || !value[0]) return true;
                            return value[0].size <= 5 * 1024 * 1024 // 5MB
                              ? true
                              : "File size must be less than 5MB";
                          },
                        },
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <div>
                          <Input
                            type="file"
                            onChange={(e) => field.onChange(e.target.files)}
                            accept="image/*"
                          />
                          {error && (
                            <span className="text-danger">{error.message}</span>
                          )}
                        </div>
                      )}
                    />
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" type="submit">
                  Submit Payout
                </Button>
                <Button
                  color="secondary"
                  onClick={() => {
                    setShowPayoutModal(false);
                    reset();
                  }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </Form>
          </Modal>
        )}

      {/* Agent Detail Modal */}
      <Modal isOpen={detailModalOpen} toggle={() => setDetailModalOpen(false)} size="lg" centered>
        <ModalHeader toggle={() => setDetailModalOpen(false)} className="border-bottom-0 pb-0">
          <span className="fw-bold text-dark fs-5">Agent Profile & Details</span>
        </ModalHeader>
        <ModalBody className="px-4 pb-4">
          {selectedAgentDetail && (
            <div>
              {/* Hero Card */}
              <div
                className="text-center mb-4 p-4 rounded-4 position-relative overflow-hidden"
                style={{
                  background: "linear-gradient(135deg, #1b9aaa 0%, #16827c 100%)",
                  color: "#ffffff",
                  boxShadow: "0 8px 24px rgba(22, 130, 124, 0.25)",
                }}
              >
                <div className="d-inline-block position-relative mb-2">
                  {selectedAgentDetail.image ? (
                    <img
                      src={`${mediaUrl}/${selectedAgentDetail.image}`}
                      alt={selectedAgentDetail.agent_name || "Agent"}
                      width="90"
                      height="90"
                      style={{
                        objectFit: "cover",
                        borderRadius: "50%",
                        border: "3px solid #ffffff",
                        boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                      }}
                    />
                  ) : (
                    <div
                      className="d-flex align-items-center justify-content-center bg-white text-dark rounded-circle mx-auto fw-bold fs-3"
                      style={{ width: "90px", height: "90px", border: "3px solid #ffffff" }}
                    >
                      {(selectedAgentDetail.agent_name ? selectedAgentDetail.agent_name.charAt(0) : "A").toUpperCase()}
                    </div>
                  )}
                </div>
                <h3 className="fw-bold text-white mb-1">
                  {selectedAgentDetail.agent_name}
                  {selectedAgentDetail.is_terms_and_conditions == 1 && (
                    <i className="fa fa-check-circle text-warning ms-2" title="Verified Agent" />
                  )}
                </h3>
                <p className="text-white-50 small mb-2">{selectedAgentDetail.email}</p>
                <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap">
                  <span
                    className="badge rounded-pill px-3 py-2 fw-semibold"
                    style={{
                      backgroundColor: selectedAgentDetail.is_online === 1 ? "#10b981" : selectedAgentDetail.is_online === 2 ? "#f59e0b" : "#6b7280",
                      color: "#ffffff",
                      fontSize: "12px",
                    }}
                  >
                    ● {selectedAgentDetail.is_online === 1 ? "Online" : selectedAgentDetail.is_online === 2 ? "On Call" : "Offline"}
                  </span>
                  <span
                    className="badge rounded-pill px-3 py-2 fw-semibold"
                    style={{
                      backgroundColor: selectedAgentDetail.is_active === 1 ? "rgba(255,255,255,0.25)" : "rgba(239, 68, 68, 0.8)",
                      backdropFilter: "blur(4px)",
                      color: "#ffffff",
                      fontSize: "12px",
                    }}
                  >
                    {selectedAgentDetail.is_active === 1 ? "● Active Agent" : "● Disabled"}
                  </span>
                </div>
              </div>

              {/* Navigation Tabs */}
              <Nav tabs className="border-tab mb-4 flex-wrap gap-1">
                <NavItem>
                  <NavLink
                    className={modalActiveTab === "1" ? "active" : ""}
                    onClick={() => setModalActiveTab("1")}
                    style={{ cursor: "pointer", fontWeight: "600" }}
                  >
                    <i className="fa fa-user me-2 text-info" /> Profile Information
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={modalActiveTab === "2" ? "active" : ""}
                    onClick={() => setModalActiveTab("2")}
                    style={{ cursor: "pointer", fontWeight: "600" }}
                  >
                    <i className="fa fa-chart-line me-2 text-primary" /> Performance & Financial Metrics
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={modalActiveTab === "3" ? "active" : ""}
                    onClick={() => setModalActiveTab("3")}
                    style={{ cursor: "pointer", fontWeight: "600" }}
                  >
                    <i className="fa fa-university me-2 text-success" /> Bank Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={modalActiveTab === "4" ? "active" : ""}
                    onClick={() => setModalActiveTab("4")}
                    style={{ cursor: "pointer", fontWeight: "600" }}
                  >
                    <i className="fa fa-file-text me-2 text-warning" /> Uploaded Documents
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={modalActiveTab}>
                {/* Tab 1: Profile Information */}
                <TabPane tabId="1">
                  <h6 className="fw-bold text-dark mb-3 text-uppercase tracking-wider fs-7">
                    <i className="fa fa-user me-2 text-info" /> Profile Details
                  </h6>
                  <Row className="g-3">
                    <Col md={6}>
                      <div className="p-3 border rounded-3 bg-white shadow-sm h-100 d-flex align-items-center">
                        <div
                          className="rounded-3 d-flex align-items-center justify-content-center me-3"
                          style={{ width: "42px", height: "42px", backgroundColor: "#e0f2fe", color: "#0284c7" }}
                        >
                          <Phone size={20} />
                        </div>
                        <div>
                          <span className="text-muted small d-block fw-semibold">Phone Number</span>
                          <strong className="text-dark">{formatPhoneNumber(selectedAgentDetail.phone)}</strong>
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="p-3 border rounded-3 bg-white shadow-sm h-100 d-flex align-items-center">
                        <div
                          className="rounded-3 d-flex align-items-center justify-content-center me-3"
                          style={{ width: "42px", height: "42px", backgroundColor: "#f0fdf4", color: "#166534" }}
                        >
                          <Mail size={20} />
                        </div>
                        <div>
                          <span className="text-muted small d-block fw-semibold">Email Address</span>
                          <strong className="text-dark">{selectedAgentDetail.email || "N/A"}</strong>
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="p-3 border rounded-3 bg-white shadow-sm h-100 d-flex align-items-center">
                        <div
                          className="rounded-3 d-flex align-items-center justify-content-center me-3"
                          style={{ width: "42px", height: "42px", backgroundColor: "#fef3c7", color: "#b45309" }}
                        >
                          <Globe size={20} />
                        </div>
                        <div>
                          <span className="text-muted small d-block fw-semibold">Languages Spoken</span>
                          <div className="d-flex align-items-center gap-1 flex-wrap mt-1">
                            {selectedAgentDetail.languages?.map((lang: any, idx: number) => (
                              <span key={idx} className="badge bg-light text-dark border me-1">
                                {lang.icon && (
                                  <img
                                    src={`${mediaUrl}/${lang.icon}`}
                                    alt={lang.language}
                                    width="14"
                                    height="14"
                                    className="rounded-circle me-1"
                                  />
                                )}
                                {lang.language}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="p-3 border rounded-3 bg-white shadow-sm h-100 d-flex align-items-center">
                        <div
                          className="rounded-3 d-flex align-items-center justify-content-center me-3"
                          style={{ width: "42px", height: "42px", backgroundColor: "#fae8ff", color: "#86198f" }}
                        >
                          <MapPin size={20} />
                        </div>
                        <div>
                          <span className="text-muted small d-block fw-semibold">Address / Location</span>
                          <strong className="text-dark">{selectedAgentDetail.address || "N/A"}</strong>
                        </div>
                      </div>
                    </Col>

                    <Col md={12}>
                      <div className="p-3 border rounded-3 bg-white shadow-sm d-flex align-items-center justify-content-between flex-wrap gap-2">
                        <div className="d-flex align-items-center">
                          <div
                            className="rounded-3 d-flex align-items-center justify-content-center me-3"
                            style={{ width: "42px", height: "42px", backgroundColor: "#fff7ed", color: "#c2410c" }}
                          >
                            <Star size={20} />
                          </div>
                          <div>
                            <span className="text-muted small d-block fw-semibold">Rating & Reviews</span>
                            <strong className="text-dark">{selectedAgentDetail.average_rating || 0} / 5.0 ({selectedAgentDetail.rating_count || 0} Reviews)</strong>
                          </div>
                        </div>
                        <StarRatings
                          rating={selectedAgentDetail.average_rating || 0}
                          starRatedColor="#ffd700"
                          numberOfStars={5}
                          starDimension="20px"
                          starSpacing="2px"
                        />
                      </div>
                    </Col>
                  </Row>
                </TabPane>

                {/* Tab 2: Performance & Financial Metrics */}
                <TabPane tabId="2">
                  <h6 className="fw-bold text-dark mb-3 text-uppercase tracking-wider fs-7">
                    <i className="fa fa-chart-line me-2 text-primary" /> Performance & Financial Metrics
                  </h6>
                  <Row className="g-3">
                    <Col md={4}>
                      <div className="p-3 border rounded-3 bg-white shadow-sm text-center h-100">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                          style={{ width: "40px", height: "40px", backgroundColor: "#e0f2fe", color: "#0284c7" }}
                        >
                          <Clock size={20} />
                        </div>
                        <span className="text-muted small d-block fw-semibold">Total Call Duration</span>
                        <h5 className="fw-bold text-dark mb-0 mt-1">{selectedAgentDetail.total_call_duration || "0 Mins"}</h5>
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="p-3 border rounded-3 bg-white shadow-sm text-center h-100">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                          style={{ width: "40px", height: "40px", backgroundColor: "#dcfce7", color: "#15803d" }}
                        >
                          <DollarSign size={20} />
                        </div>
                        <span className="text-muted small d-block fw-semibold">Revenue Generated</span>
                        <h5 className="fw-bold text-success mb-0 mt-1">{selectedAgentDetail.total_customer_amount || "₹0.00"}</h5>
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="p-3 border rounded-3 bg-white shadow-sm text-center h-100">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                          style={{ width: "40px", height: "40px", backgroundColor: "#fef9c3", color: "#a16207" }}
                        >
                          <Activity size={20} />
                        </div>
                        <span className="text-muted small d-block fw-semibold">Pending Payout</span>
                        <h5 className="fw-bold text-warning mb-0 mt-1">{selectedAgentDetail.total_amount || "₹0.00"}</h5>
                      </div>
                    </Col>
                  </Row>
                </TabPane>

                {/* Tab 3: Bank Details */}
                <TabPane tabId="3">
                  <div className="p-4 border rounded-3 bg-white shadow-sm">
                    <div className="d-flex align-items-center mb-3">
                      <div className="rounded-3 d-flex align-items-center justify-content-center me-3 p-3 bg-light text-success fs-4">
                        <i className="fa fa-university" />
                      </div>
                      <div>
                        <h6 className="fw-bold mb-0 text-dark">Banking & Payout Details</h6>
                        <span className="text-muted small">Banking information provided during agent registration</span>
                      </div>
                    </div>
                    {selectedAgentDetail.bankingdetail ? (
                      <div className="p-3 bg-light rounded-3 font-mono text-dark border" style={{ whiteSpace: "pre-wrap" }}>
                        {selectedAgentDetail.bankingdetail}
                      </div>
                    ) : (
                      <div className="text-center p-4 text-muted border rounded-3 bg-light">
                        <i className="fa fa-info-circle fs-4 mb-2 d-block text-muted" />
                        <p className="mb-0">No bank details added for this agent.</p>
                      </div>
                    )}
                  </div>
                </TabPane>

                {/* Tab 4: Uploaded Documents */}
                <TabPane tabId="4">
                  {(() => {
                    const docs = Array.isArray(selectedAgentDetail.documents)
                      ? selectedAgentDetail.documents
                      : typeof selectedAgentDetail.documents === "string"
                      ? JSON.parse(selectedAgentDetail.documents || "[]")
                      : [];
                    if (!docs || docs.length === 0) {
                      return (
                        <div className="text-center p-4 text-muted border rounded-3 bg-light">
                          <FileText size={36} className="mb-2 text-muted" />
                          <p className="mb-0">No documents uploaded for this agent.</p>
                        </div>
                      );
                    }
                    return (
                      <Row className="g-3">
                        {docs.map((doc: any, idx: number) => {
                          const fileUrl = doc.image ? `${mediaUrl}/${doc.image}` : null;
                          return (
                            <Col md={6} key={idx}>
                              <div className="p-3 border rounded-3 bg-white shadow-sm h-100">
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                  <strong className="text-dark">{doc.name || `Document #${idx + 1}`}</strong>
                                  {fileUrl && (
                                    <a
                                      href={fileUrl}
                                      target="_blank"
                                      rel="noreferrer"
                                      className="btn btn-outline-primary btn-xs px-2 py-1"
                                    >
                                      View Document <i className="fa fa-external-link ms-1" />
                                    </a>
                                  )}
                                </div>
                                {fileUrl ? (
                                  <div className="text-center bg-light p-2 rounded-2 border">
                                    <img
                                      src={fileUrl}
                                      alt={doc.name || "Document"}
                                      className="img-fluid rounded"
                                      style={{ maxHeight: "160px", objectFit: "contain" }}
                                    />
                                  </div>
                                ) : (
                                  <div className="text-muted small">No file attached</div>
                                )}
                              </div>
                            </Col>
                          );
                        })}
                      </Row>
                    );
                  })()}
                </TabPane>
              </TabContent>
            </div>
          )}
        </ModalBody>
      </Modal>
      </Container>
    </>
  );
}

// //////////without pagination
// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   Card,
//   CardBody,
//   Col,
//   Container,
//   FormGroup,
//   Nav,
//   NavItem,
//   NavLink,
//   Row,
//   Spinner,
//   TabContent,
//   TabPane,
// } from "reactstrap";
// import { Link } from "react-router-dom";
// import { PlusSquare, Wifi, WifiOff, Target, PhoneCall } from "react-feather"; // added PhoneCall
// import axios from "axios";
// import FilterComponent from "../../../Components/Tables/DataTables/Common/FilterComponent";
// import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
// import { ViewAgentTitle, AgentTitle, Href } from "../../../Utils/Constants";
// import { Badges, H5, P, UL, LI, Image, Btn } from "../../../AbstractElements";
// import { baseUrl, mediaUrl } from "../../../Utils/FileUpload";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// // ✅ Updated with "On Call" status tab
// const projectListNavList = [
//   { id: 1, icon: <Target />, text: "All" },
//   { id: 2, icon: <Wifi />, text: "Online" },
//   { id: 3, icon: <WifiOff />, text: "Offline" },
//   { id: 4, icon: <PhoneCall />, text: "On Call" }, // new tab
// ];
// interface Agent {
//   id: string;
//   agent_name: string;
//   email: string;
//   address: string;
//   phone: string;
//   image: string;
//   is_online: number;
//   is_active: number;
//   languages?: { language: string; icon: string }[];
//   brands?: { brand_name: string; logo: string }[];
//   is_deleted: number;
// }

// export default function ViewAgent() {
//   const [activeTab, setActiveTab] = useState(1);
//   const [disabledDelete, setDisabledDelete] = useState<string | null>(null);
//   const [disableAllDelete, setDisableAllDelete] = useState(false);
//   const [filteredItems, setFilteredItems] = useState<Agent[]>([]);
//   const [refresh, setRefresh] = useState<number>(0);
//   const [loading, setLoading] = useState(false);
//   const [disabledEnable, setDisabledEnable] = useState<string | null>(null);
//   const [disableAllEnable, setDisableAllEnable] = useState(false);
//   const navigate = useNavigate();
//   const token = localStorage.getItem("token");
//   const [filterText, setFilterText] = useState("");

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(`${baseUrl}agent/getall`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         const data: Agent[] = response.data;
//         // setFilteredItems(
//         //   data
//         //     .filter((brand) => brand.is_deleted === 0)
//         //     .sort((a, b) => b.is_active - a.is_active)
//         // );
//         setFilteredItems(data);
//         // console.log(data)
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [refresh]);

//   const handleAdd = () => {
//     navigate("/add_agent");
//   };

//   const handlehistory = () => {
//     navigate("/call_history");
//   };

//   // ✅ Updated filter logic
//   const getFilteredAgents = () => {
//     let agents = filteredItems;

//     // Apply tab filter
//     switch (activeTab) {
//       case 2:
//         agents = agents.filter((item: any) => item.is_online === 1);
//         break;
//       case 3:
//         agents = agents.filter((item: any) => item.is_online === 0);
//         break;
//       case 4:
//         agents = agents.filter((item: any) => item.is_online === 2);
//         break;
//       default:
//         break;
//     }

//     // Apply search filter
//     if (filterText.trim() !== "") {
//       const lowerSearch = filterText.toLowerCase();

//       agents = agents.filter((item: Agent) => {
//         const matchAgentName = item.agent_name?.toLowerCase().includes(lowerSearch);
//         const matchEmail = item.email?.toLowerCase().includes(lowerSearch);
//         const matchPhone = item.phone?.toLowerCase().includes(lowerSearch);
//         const matchAddress = item.address?.toLowerCase().includes(lowerSearch);

//         const matchLanguages = item.languages?.some((lang: any) =>
//           lang.language.toLowerCase().includes(lowerSearch)
//         );

//         const matchBrands = item.brands?.some((brand: any) =>
//           brand.brand_name.toLowerCase().includes(lowerSearch)
//         );

//         return (
//           matchAgentName ||
//           matchEmail ||
//           matchPhone ||
//           matchAddress ||
//           matchLanguages ||
//           matchBrands
//         );
//       });
//     }

//     return agents;
//   };

//   if (loading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <Spinner color="primary" />
//       </div>
//     );
//   }

//   const handleEdit = (id: string) => {
//     navigate("/edit_agent", { state: { id: id } });
//   };

//   const handleagenthistory = (id: string) => {
//     navigate("/call_history", { state: { agent_id: id } });
//   };

//   const handleDelete = (id: string) => {
//     setDisabledDelete(id);
//     setDisableAllDelete(true);
//     const confirmToast = () =>
//       toast.warn(
//         <div>
//           <div>Are you sure you want to delete this agent?</div>
//           <div className="d-flex justify-content-end mt-2">
//             <Button color="danger" onClick={() => confirmDelete(id)}>
//               Yes
//             </Button>
//             <Button
//               color="secondary"
//               onClick={() => {
//                 setDisabledDelete(null);
//                 setDisableAllDelete(false);
//                 toast.dismiss();
//               }}
//               className="ms-2"
//             >
//               Cancel
//             </Button>
//           </div>
//         </div>,
//         {
//           position: "top-right",
//           autoClose: false,
//           closeOnClick: false,
//           closeButton: false,
//           draggable: false,
//           onClose: () => {
//             setDisableAllDelete(false);
//             setDisabledDelete(null);
//           },
//         }
//       );

//     const confirmDelete = async (id: string) => {
//       setDisabledDelete(null);
//       setDisableAllDelete(false);
//       toast.dismiss();
//       try {
//         await axios.post(
//           `${baseUrl}agent/delete`,
//           { id },
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         toast.success(`Agent Deleted Successfully`, {
//           position: "top-right",
//           autoClose: 1000,
//           closeOnClick: true,
//         });
//         setFilteredItems((prevItems) =>
//           prevItems.filter((item) => item.id !== id)
//         );
//       } catch (error) {
//         console.error("Error deleting agent:", error);
//         toast.error("An error occurred while deleting the agent", {
//           position: "top-right",
//           autoClose: 1000,
//           closeOnClick: true,
//         });
//       }
//     };

//     confirmToast();
//   };

//   const toggleEnable = (id: string, currentStatus: number) => {
//     setDisabledEnable(id); // reuse this state if needed
//     setDisableAllEnable(true);

//     const confirmToggle = () => {
//       toast.warn(
//         <div>
//           <div>
//             Are you sure you want to{" "}
//             <strong>{currentStatus === 1 ? "disable" : "enable"}</strong> this
//             agent?
//           </div>
//           <div className="d-flex justify-content-end mt-2">
//             <Button
//               color={currentStatus === 1 ? "danger" : "success"}
//               onClick={() => confirmToggleEnable(id, currentStatus)}
//             >
//               Yes
//             </Button>
//             <Button
//               color="secondary"
//               onClick={() => {
//                 setDisabledEnable(null);
//                 setDisableAllEnable(false);
//                 toast.dismiss();
//               }}
//               className="ms-2"
//             >
//               Cancel
//             </Button>
//           </div>
//         </div>,
//         {
//           position: "top-right",
//           autoClose: false,
//           closeOnClick: false,
//           closeButton: false,
//           draggable: false,
//           onClose: () => {
//             setDisabledEnable(null);
//             setDisableAllEnable(false);
//           },
//         }
//       );
//     };

//     const confirmToggleEnable = async (id: string, currentStatus: number) => {
//       setDisabledEnable(null);
//       setDisableAllEnable(false);
//       toast.dismiss();

//       try {
//         const newStatus = currentStatus === 1 ? 0 : 1;

//         await axios.post(
//           `${baseUrl}agent/toggle_active`,
//           { id, is_active: newStatus },
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         toast.success(
//           `Agent ${newStatus === 1 ? "enabled" : "disabled"} successfully!`,
//           {
//             position: "top-right",
//             autoClose: 1000,
//             closeOnClick: true,
//             onClose: () => {
//               setRefresh((prev) => prev + 1);
//             },
//           }
//         );
//       } catch (error) {
//         console.error("Error toggling agent:", error);
//         toast.error("Error updating enable status", {
//           position: "top-right",
//           autoClose: 1000,
//         });
//       }
//     };

//     confirmToggle();
//   };

//   const getStatusDetails = (status: number) => {
//     switch (status) {
//       case 1:
//         return { text: "Online", color: "success" };
//       case 0:
//         return { text: "Offline", color: "danger" };
//       case 2:
//         return { text: "On Call", color: "warning" };
//       default:
//         return { text: "Unknown", color: "secondary" };
//     }
//   };

//   return (
//     <>
//       <Breadcrumbs
//         pageTitle={ViewAgentTitle}
//         parent={AgentTitle}
//         title={ViewAgentTitle}
//       />
//       <Container fluid>
//         <Row className="project-cards">
//           <Col md={12} className="project-list">
//             <Card>
//               <Row>
//                 <Col md={6}>
//                   <Nav className="border-tab" tabs>
//                     {projectListNavList.map((item) => (
//                       <NavItem key={item.id}>
//                         <NavLink
//                           href={Href}
//                           className={activeTab === item.id ? "active" : ""}
//                           onClick={() => setActiveTab(item.id)}
//                         >
//                           {item.icon} {item.text}
//                         </NavLink>
//                       </NavItem>
//                     ))}
//                   </Nav>
//                 </Col>
//                 <Col md={6} className="d-md-block d-none text-end">
//                   <FormGroup className="mb-0">
//                     <Btn
//                       color="success"
//                       onClick={handlehistory}
//                       className="btn btn-primary d-flex align-items-center justify-content-center"
//                     >
//                       <PhoneCall className="me-2" /> Call History
//                     </Btn>
//                     <Btn
//                       color="primary"
//                       onClick={handleAdd}
//                       className="btn btn-primary d-flex align-items-center justify-content-center"
//                     >
//                       <PlusSquare className="me-2" /> Add Agent
//                     </Btn>
//                   </FormGroup>
//                 </Col>
//               </Row>
//             </Card>
//           </Col>

//           <Col sm={12}>
//             <Card>
//               <CardBody>
//                 <div className="mb-2">
//                 <FilterComponent
//                   onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
//                     setFilterText(e.target.value)
//                   }
//                   filterText={filterText}
//                 />
//                 </div>
//                 <TabContent activeTab={activeTab}>
//                   <TabPane tabId={activeTab}>
//                     <Row>
//                       {getFilteredAgents().map((item: any, index) => {
//                         const { text: badgeText, color: badgeColor } =
//                           getStatusDetails(item.is_online);
//                         return (
//                           <Col xxl={4} md={6} key={index}>
//                             <div
//                               className={`project-box font-dark bg-light-${badgeColor}`}
//                             >
//                               <Badges color={badgeColor}>{badgeText}</Badges>
//                               <H5 className={`f-w-500 mb-2 text-${badgeColor}`}>
//                                 {item.agent_name}
//                               </H5>
//                               <div className="d-flex mb-2 align-items-center">
//                                 <Image
//                                   className="img-30 me-2 rounded-circle"
//                                   src={`${mediaUrl}/${item.image}`}
//                                   alt="agent"
//                                 />
//                                 <P className="font-light mb-0">{item.email}</P>
//                               </div>
//                               <P className="mb-2">{item.address}</P>
//                               <Row
//                                 className="details"
//                                 style={{ height: "150px" }}
//                               >
//                                 <Col xs={4}>
//                                   <span>Phone</span>
//                                 </Col>
//                                 <Col xs={8} className={`font-${badgeColor}`}>
//                                   {item.phone}
//                                 </Col>

//                                 <Col xs={4}>
//                                   <span>Languages</span>
//                                 </Col>
//                                 <Col xs={8}>
//                                   <div className="d-flex align-items-center flex-wrap gap-1 mb-1">
//                                     {item.languages?.map(
//                                       (lang: any, idx: number) => (
//                                         <Image
//                                           key={idx}
//                                           className="img-20 rounded-circle"
//                                           src={`${mediaUrl}/${lang.icon}`}
//                                           alt={lang.language}
//                                           title={lang.language}
//                                         />
//                                       )
//                                     )}
//                                   </div>
//                                   {item.languages
//                                     ?.map((lang: any) => lang.language)
//                                     .join(", ")}
//                                 </Col>

//                                 <Col xs={4}>
//                                   <span>Brands</span>
//                                 </Col>
//                                 <Col xs={8}>
//                                   <div className="d-flex align-items-center flex-wrap gap-1 mb-1">
//                                     {item.brands?.map(
//                                       (brand: any, idx: number) => (
//                                         <Image
//                                           key={idx}
//                                           className="img-20 rounded-circle"
//                                           src={`${mediaUrl}/${brand.logo}`}
//                                           alt={brand.brand_name}
//                                           title={brand.brand_name}
//                                         />
//                                       )
//                                     )}
//                                   </div>
//                                   {item.brands
//                                     ?.map((brand: any) => brand.brand_name)
//                                     .join(", ")}
//                                 </Col>
//                               </Row>
//                               <Col xs={12} className="mt-2">
//                                 <label className="w-100">Rating</label>
//                                 {[...Array(5)].map((_, i) => (
//                                   <i
//                                     key={i}
//                                     className="fa fa-star text-warning me-1"
//                                   />
//                                 ))}
//                               </Col>

//                               <Col
//                                 xs={12}
//                                 className="mt-2"
//                                 style={{ zIndex: 2 }}
//                               >
//                                 <div className="d-flex justify-content">
//                                   <Button
//                                     color={
//                                       item.is_active ? "success" : "secondary"
//                                     }
//                                     size="sm"
//                                     onClick={() =>
//                                       toggleEnable(item.id, item.is_active)
//                                     }
//                                     disabled={
//                                       disabledEnable === item.id ||
//                                       disableAllEnable
//                                     }
//                                     style={{
//                                       marginRight: "5px",
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                     }}
//                                     title={
//                                       item.is_active ? "Disable" : "Enable"
//                                     }
//                                   >
//                                     <i
//                                       className={`fa ${
//                                         item.is_active
//                                           ? "fa-check-circle"
//                                           : "fa-ban"
//                                       }`}
//                                     />
//                                   </Button>

//                                   <Button
//                                     color="primary"
//                                     size="sm"
//                                     onClick={() => handleEdit(item.id)}
//                                     style={{
//                                       marginRight: "5px",
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                     }}
//                                   >
//                                     <i className="icon-pencil-alt " />
//                                   </Button>
//                                   <Button
//                                     color="danger"
//                                     size="sm"
//                                     onClick={() => handleDelete(item.id)}
//                                     disabled={
//                                       disabledDelete === item.id ||
//                                       disableAllDelete
//                                     }
//                                     style={{
//                                       marginRight: "5px",
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                     }}
//                                   >
//                                     <i className="icon-trash" />
//                                   </Button>
//                                   <Button
//                                     color="info"
//                                     size="sm"
//                                     onClick={() => handleagenthistory(item.id)}
//                                     style={{
//                                       marginRight: "5px",
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                     }}
//                                     title="View Call History"
//                                   >
//                                     <i className="fa fa-phone" />
//                                   </Button>
//                                 </div>
//                               </Col>
//                             </div>
//                           </Col>
//                         );
//                       })}
//                     </Row>
//                   </TabPane>
//                 </TabContent>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//       <ToastContainer />
//     </>
//   );
// }
